export default __webpack_public_path__ + "static/media/downAccordion.77b989b3.svg";